import { render, staticRenderFns } from "./lexisBridger.vue?vue&type=template&id=43ae7920&scoped=true&"
import script from "./lexisBridger.vue?vue&type=script&lang=js&"
export * from "./lexisBridger.vue?vue&type=script&lang=js&"
import style0 from "./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss?vue&type=style&index=0&id=43ae7920&prod&scoped=true&lang=scss&"
import style1 from "./lexisBridger.vue?vue&type=style&index=1&id=43ae7920&prod&scoped=true&lang=css&"
import style2 from "./lexisBridger.vue?vue&type=style&index=2&id=43ae7920&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae7920",
  null
  
)

export default component.exports